import React from "react";
import { Remarkable } from "remarkable";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

const Markdown = ({ data }) => {
    const { markdown } = data || {};
    // Markdown parser
    const md = new Remarkable({
        html: true,
        xhtmlOut: true,
    });
    // The content to place in the DOM
    const markdownContent = markdown?.markdown ? md.render(markdown?.markdown) : "";
    // Sanitizing the html content
    const sanitizedHtmlContent = renderSanitizedHtmlContent(markdownContent);
    // eslint-disable-next-line react/no-danger
    return markdownContent && <div dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }} />;
};
export default Markdown;
